import { useState, type JSX } from 'react';
import { Button } from '../components/Button.js';
import { useT } from '../i18n/index.js';
import { useApp } from '../state/store.js';
import './AgeGate.css';

/**
 * S2 — the 18+ self-attestation gate. Copy is verbatim from design spec §13 and
 * must not be reworded: it is what both store questionnaires are answered
 * against (PRD §11.1–2). "Labas muna ako" is a genuine dead end — an exit that
 * quietly returns you to the app is not a gate.
 */
export function AgeGate(): JSX.Element {
  const accept = useApp((s) => s.acceptAgeGate);
  const setToast = useApp((s) => s.setToast);
  const t = useT();
  const [left, setLeft] = useState(false);
  const [busy, setBusy] = useState(false);

  if (left) {
    return (
      <div className="agegate">
        <div className="agegate__exit">
          <h1>{t('results.age.left.title')}</h1>
          <p>{t('results.age.left.body')}</p>
          <p>{t('results.age.left.back')}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="agegate">
      <div className="agegate__card">
        <div className="agegate__mark">
          <span className="agegate__18" aria-hidden="true">
            18+
          </span>
          <h1 className="agegate__title">{t('results.age.title')}</h1>
        </div>

        <p className="agegate__body">{t('results.age.body')}</p>

        <div className="agegate__actions">
          <Button
            variant="primary"
            disabled={busy}
            onClick={() => {
              setBusy(true);
              accept().catch((e: Error) => {
                setBusy(false);
                setToast(t('results.age.error', { error: e.message }), 'warn');
              });
            }}
          >
            {t('results.age.accept')}
          </Button>
          <Button variant="ghost" onClick={() => setLeft(true)}>
            {t('results.age.exit')}
          </Button>
        </div>

        <p className="agegate__fine">{t('results.disclosure')}</p>
      </div>
    </div>
  );
}
